module.exports = __webpack_public_path__ + "img/bg_img01.033e5b93.png";